import React from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import MultiChoice from './MultiChoice';

export default class DataFlowMapMultiChoice extends React.Component {
  static defaultProps = {
    onChange: () => alert('DataFlowMapMultiChoice Onchange'),
    selected: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    const selected = [];

    // Mirrored by Tp_Communication/Enum/DataFlowMapSystemTextEnum.cs, which the contract-import prompt reads
    // from - the stored value is matched by exact string, so change the two together.
    const optValues = [
      { label: 'Apollo', value: 'Apollo' },
      { label: 'BARE-ify', value: 'BARE-ify' },
      { label: 'Prism', value: 'Prism' },
      { label: 'Research Metrics', value: 'Research Metrics' },
      { label: 'PointerPro', value: 'PointerPro' },
      { label: 'Mention', value: 'Mention' },
      { label: 'Advanced Analytics Powered by DOMO', value: 'Advanced Analytics Powered by DOMO' },
      { label: 'Other', value: 'Other' },
    ];

    optValues.forEach((mapField) => {
      if (this.props.selected && this.props.selected.includes(mapField.label)) {
        selected.push(mapField);
      }
    });
    this.setState({
      itemList: optValues,
      loading: false,
      selected: selected,
    });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected });
    this.props.onChange(selected.map((i) => i.value));
  }

  renderList() {
    return (
      <MultiChoice
        options={this.state.itemList}
        selected={this.props.selected}
        onChange={this.props.onChange}
      />
    );
  }

  render() {
    return (
      <div className={'text-center arial w-100 text-center hover rounded arial m-1 p-1'}>
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
